module.exports = __webpack_public_path__ + "assets/img/vertical-support-bar.cfaf5436.png";